import React from 'react';
import { useNavigate, useLocation } from 'react-router-dom';
import { TabSwitcher } from 'components';
import { timeSheetTabEnums, timeSheetTabTypes } from './constants';
import { ActivePayroll } from './activePayroll';
import { ActiveTimeSheetFilter } from './fragments/activeTimeSheetFilter';
import { ProcessedTimeSheetFilter } from './fragments/processedTimeSheetFilter';
import { ProcessesPayroll } from './processesPayroll';
import { TimeSheetSelectedFilters } from './fragments/timeSheetSelectedFilters';

export const TimeSheet = () => {
    const navigate = useNavigate();
    const location = useLocation();
    const info = location?.state;
    const checkActive = info?.tabType ? info?.tabType === timeSheetTabEnums?.ACTIVE : timeSheetTabEnums?.ACTIVE;
    const checkProcessed = info?.tabType === timeSheetTabEnums?.PROCESSED;

    return (
        <div>
            <div className="space-between" style={{ alignItems: 'flex-end', marginBottom: 12 }}>
                <TabSwitcher list={timeSheetTabTypes} defaultType={timeSheetTabEnums?.ACTIVE} />
                {checkActive && <ActiveTimeSheetFilter />}
                {checkProcessed && <ProcessedTimeSheetFilter />}
            </div>

            <TimeSheetSelectedFilters />

            <div>
                {checkActive && <ActivePayroll />}
                {checkProcessed && <ProcessesPayroll />}
            </div>
        </div>
    );
};
